import React, { FC } from "react";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import { PaymentMethodCard } from "../../../../Components/PaymentMethodCard/PaymentMethodCard";
import messages from "./messages";
import { IPaymentMethod } from "@modules/PaymentProcessing/services/paymentMethods";
import { PaymentMethodType } from "@modules/PaymentProcessing/types";

interface Props {
  onClick: (paymentMethod: IPaymentMethod) => void;
  disabled?: boolean;
}

export const BankTransferPaymentCard: FC<Props> = ({ onClick, disabled }) => {
  const handleClick = () => {
    onClick(PaymentMethodType.BANK_TRANSFER);
  };

  return (
    <PaymentMethodCard
      title={<FormattedMessage {...messages.bankTransfer} />}
      onClick={handleClick}
      cardNetworkIcons={[]}
      value={PaymentMethodType.BANK_TRANSFER}
      disabled={disabled}
      data-testid="bank-transfer-payment-link"
      disabledModalTitle={<FormattedMessage {...messages.noBankTransfer} />}
      disabledModalContent={
        <FormattedMessage
          {...messages.bankTransferTransactionsAreNotSupportedForThisService}
        />
      }
    />
  );
};
